module.exports = __webpack_public_path__ + "img/amex-large.d384dd13.svg";